import type {
  RyftDocumentUploadRequestType,
  RyftDocumentUploadResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

type RyftDocumentUploadParameters = RyftDocumentUploadRequestType & {
  front: File;
  back?: File;
};

export const useRyftManagementDocumentUpload = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      front,
      back,
      documentType,
    }: RyftDocumentUploadParameters) => {
      const data = new FormData();
      data.append("front", front);
      if (back) {
        data.append("back", back);
      }
      data.append("documentType", documentType);

      return apiV2Request({
        user,
        business,
        method: "post",
        path: "ryft-management/accounts/documents",
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as RyftDocumentUploadResponseType,
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.RyftManagementAccount,
        ],
      });
    },
  });
};
